import React, { Component } from 'react'
import dayjs from 'dayjs'
import { adminGetSubscriptionHistory } from '../../../../../api'
import { Col, Row } from '../../../../Shared/Grid'
import Alert from '../../../../Shared/Alert'
import Loader from '../../../../Shared/Loader'
import PropTypes from 'prop-types'
import Pagination from '../../../../Shared/Pagination'
import { withTranslation } from 'react-i18next'

class OrderHistory extends Component {

  constructor (props) {
    super(props)
    this.state = {
      history: [],
      total: 0,
      error: null,
      loading: true,
      pagination: {
        offset: 0,
        limit: 5
      }
    }
  }

  componentDidMount () {
    this.getHistoryNew(this.props.id)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.id !== prevProps.id || this.props.refreshIndicator !== prevProps.refreshIndicator) {
      this.getHistoryNew(this.props.id)
    }
  }

  getHistoryNew (id) {
    let pagination = { ...this.state.pagination }
    pagination.offset = 0
    this.setState({
      pagination: pagination
    }, () => {
      this.getHistory(id)
    })
  }

  getHistory (id) {
    this.setState({ loading: true, error: false }, () => {
      adminGetSubscriptionHistory(id, this.state.pagination.offset, this.state.pagination.limit).fetchPromise.then((response) => {
        if (!Array.isArray(response.entries)) {
          throw new Error('history not an array')
        }
        this.setState({ loading: false, history: response.entries, total: response.count })
      }).catch(() => {
        this.setState({ loading: false, error: true })
      })
    })
  }

  createHistoryRow (item) {
    return (
      <div className="order-comment" key={item.id}>
        <div>Status: {this.getOrderStatus(item.workflowStatus)}</div>
        <div>{this.props.t('BILLING_STATUS')}: {this.getOrderStatusBool(item.billingStatus)}</div>
        <div>{this.props.t('PAYMENT_STATUS')}: {this.getOrderStatusBool(item.paymentStatus)}</div>
        <div>{this.props.t('CANCELLATION_DATE')}: {item.cancellationDate === null ? '' : dayjs(item.cancellationDate).locale(this.props.i18n.language).format('L')}</div>
        <div className={'order-comment-footer'}>
          <span>{item.userCode}</span>
          <span>{item.modifiedAt ? dayjs(item.modifiedAt).locale(this.props.i18n.language).format('L LT') : '-'}</span>
        </div>
      </div>
    )
  }

  getOrderStatus (status) {
    switch (status) {
      case 0:
        return this.props.t('ORDER_WORKFLOW_STATUS_UNPROCESSED')
      case 1:
        return this.props.t('ORDER_WORKFLOW_STATUS_PROCESSED')
      default:
        return '-'
    }
  }

  getOrderStatusBool (status) {
    switch (status) {
      case 0:
        return this.props.t('STATUS_INACTIVE')
      case 1:
        return this.props.t('STATUS_ACTIVE')
      default:
        return '-'
    }
  }

  onPaginationChange = (page) => {
    let pagination = { ...this.state.pagination }
    pagination.offset = Pagination.calculateOffset(page, this.state.pagination.limit)
    this.setState({
      pagination: pagination
    }, () => {
      this.getHistory(this.props.id)
    })
  }

  render () {
    const { t } = this.props
    const currentPage = Pagination.calculatePage(this.state.pagination.offset, this.state.pagination.limit)

    return (
      <Row style={{ position: 'relative' }}>
        {this.state.loading ? <Loader size={32}/> : null}
        <Col xs={12}>
          <h3>{t('HISTORY')}</h3>
        </Col>
        <Col xs={12}>
          {this.state.error ? <Alert type={'danger'}>Failed to fetch history</Alert> : null}
          {!this.state.error ?
            this.state.history.length > 0 ?
              this.state.history.map(historyItem => this.createHistoryRow(historyItem))
              : <Alert type={'info'}>{t('NO_HISTORY_FOUND')}</Alert>
            : null}
        </Col>
        {this.state.total > 0 ?
          <Col xs={12}>
            <Pagination style={{ marginLeft: 'auto', float: 'right' }} current={currentPage} total={this.state.total}
                        pageSize={this.state.pagination.limit}
                        onChange={this.onPaginationChange}/>
          </Col>
          : null}
      </Row>
    )
  }
}

OrderHistory.propTypes = {
  id: PropTypes.number,
  refreshIndicator: PropTypes.any
}

export default withTranslation()(OrderHistory)
